import { Box, Modal } from "@mui/material";
import { useEffect, useState } from "react";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { getShareholderLog } from "../service/ConfigService";
import ArrowCircleRightOutlinedIcon from "@mui/icons-material/ArrowCircleRightOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";

function formatDate(isoString) {
  const date = new Date(isoString);

  const options = {
    year: "numeric",
    month: "short", // abbreviated month name (e.g., "Mar")
    day: "numeric", // day of the month (e.g., "1")
    hour: "numeric", // hour (e.g., "3")
    minute: "numeric", // minute (e.g., "53")
    hour12: true, // 12-hour format with AM/PM
  };

  return date.toLocaleString("en-US", options);
}

const ViewShareholderModal = ({
  modalProps = {},
  onClose,
  existingShareholder = null,
}) => {
  const [step, setStep] = useState(1);
  const [logs, setLogs] = useState([]);
  const getter = getShareholderLog(
    () => {},
    {
      is_change_position: true,
      sid: existingShareholder.sid,
      with_update: true,
    },
    (resp) => {
      setLogs(resp?.data || []);
    },
  );
  useEffect(() => {
    getter();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Modal {...modalProps}>
      <Box
        sx={{
          position: "absolute",
          top: "55%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          overflow: "scroll",
          bgcolor: "background.paper",
          borderRadius: "10px",
          boxShadow: 24,
          minWidth: 500,
        }}
      >
        {step === 1 && (
          <div className='flex flex-col '>
            <div className='font-semibold px-4 py-5 border-b'>
              <div className='flex flex-row gap-2'>
                <CloseOutlinedIcon
                  className='cursor-pointer'
                  onClick={onClose}
                />
                <h2>Shareholder Details</h2>
              </div>
            </div>
            <div className='px-4 py-5 flex flex-col gap-6'>
              <div className='flex flex-col gap-2'>
                <p className='text-[#5F737F]'>Name</p>
                <p>{existingShareholder.name}</p>
              </div>
              <div className='flex flex-col gap-2'>
                <p className='text-[#5F737F]'>SID</p>
                <p>{existingShareholder.sid}</p>
              </div>
              <div className='flex flex-col gap-2'>
                <p className='text-[#5F737F]'>Bank Account Number</p>
                <p>{existingShareholder.bank_account_number || '-'}</p>
              </div>
              <div className='flex flex-col gap-2'>
                <p className='text-[#5F737F]'>Bank Account Holder</p>
                <p>{existingShareholder.bank_account_holder || '-'}</p>
              </div>
              <div className='flex flex-col gap-2'>
                <p className='text-[#5F737F]'>Position</p>
                <p>{existingShareholder.position}</p>
              </div>
              <div className='flex flex-col gap-2'>
                <p className='text-[#5F737F]'></p>
                <p
                  className='font-bold text-[#556FB5] cursor-pointer'
                  onClick={() => setStep(2)}
                >
                  View Changelog
                </p>
              </div>
            </div>
          </div>
        )}
        {step === 2 && (
          <div className='flex flex-col '>
            <div className='font-semibold px-4 py-5 border-b flex gap-4'>
              <ChevronLeftIcon
                className='cursor-pointer'
                onClick={() => {
                  setStep(1);
                }}
              />
              <h2>Changelog</h2>
            </div>
            <div className='px-4 py-5 flex flex-col gap-6'>
              <div className='flex flex-col gap-6'>
                {logs.map((log) => (
                  <div className='text-sm flex flex-col gap-4 border-b pb-4'>
                    <div>
                      <span className='font-medium'>{log.full_name} </span>
                      <span className='text-[#5F737F]'>changed position</span>
                      <span className='float-right text-xs'>
                        {formatDate(log.log_time)}
                      </span>
                    </div>
                    <div className='flex gap-2'>
                      <span>{log.metadata?.from_position || "-"}</span>
                      <ArrowCircleRightOutlinedIcon className='!text-gray-300' />
                      <span>{log.metadata?.to_position || "-"}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </Box>
    </Modal>
  );
};

export default ViewShareholderModal;
